import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { ProyectoEvntDTO } from "../interfaces/ProyectosDTOS/EventoProyDTO";
import { EvntAdjuntarProyectoDTO } from "../interfaces/ProyectosDTOS/EvntAdjuntoProyectoDTO";
import { EvntHistorialProyectoDTO } from "../interfaces/ProyectosDTOS/EvntHistorialProyectoDTO";
const localBack : string = process.env.REACT_APP_BACK || ''; 
const APICATALOGO : string = '/api/Evento';

export default class EventoService{
  async GuardarEvento(evento:ProyectoEvntDTO,token:any): Promise<ResponceApi<ProyectoEvntDTO>> {        
    try {
        const response: AxiosResponse<ResponceApi<ProyectoEvntDTO>> = await axios.post(
          localBack + APICATALOGO + '/PostEventosContext',
          evento,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );            
        if (response.data) {
            //console.log(response.data)
            return response.data;
        } else {
            throw new Error('No se recibieron datos válidos.');
        }
      } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        throw error; // Re-lanzar el error para que se maneje donde se llama a la función
      }
  }
  async GuardarEventoProductoIngresado(evento:ProyectoEvntDTO,token:any): Promise<ResponceApi<ProyectoEvntDTO>> {        
    try {
        const response: AxiosResponse<ResponceApi<ProyectoEvntDTO>> = await axios.post(
          localBack + APICATALOGO + '/PostEventosProductosContext',
          evento,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );            
        if (response.data) {
            //console.log(response.data)
            return response.data;
        } else {
            throw new Error('No se recibieron datos válidos.');
        }
      } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        throw error; // Re-lanzar el error para que se maneje donde se llama a la función
      }
  }
  async GuardarEventoProductoAdjuntado(evento:EvntAdjuntarProyectoDTO,token:any): Promise<ResponceApi<ProyectoEvntDTO>> {        
    try {
        const response: AxiosResponse<ResponceApi<ProyectoEvntDTO>> = await axios.post(
          localBack + APICATALOGO + '/PostEvntAdjProductoProyectoContext',
          evento,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );            
        if (response.data) {
            //console.log(response.data)
            return response.data;
        } else {
            throw new Error('No se recibieron datos válidos.');
        }
      } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        throw error; // Re-lanzar el error para que se maneje donde se llama a la función
      }
  }
  async GetEventosByIdProyecto(id:number, token:any): Promise<ResponceApi<ProyectoEvntDTO>>{
    const response1:AxiosResponse<ResponceApi<ProyectoEvntDTO>> = 
    await axios.get(localBack+APICATALOGO+'/GetEventosByIdProyecto/'+id,
    {
        headers: {
          Authorization: `Bearer ${token}`
        }
    });
    //console.log(response1.data);        
    return response1.data;
  }
  async GetEventosByIdInvestigador(id:number, token:any): Promise<ResponceApi<EvntHistorialProyectoDTO>>{
    const response1:AxiosResponse<ResponceApi<EvntHistorialProyectoDTO>> = 
    await axios.get(localBack+APICATALOGO+'/GetEventosByIdInv/'+id,
    {
        headers: {
          Authorization: `Bearer ${token}`
        }
    });
    //console.log(response1.data);        
    return response1.data;
  }
}